import { ServiceList } from './models';

export const services: ServiceList = {
    Services: [
        {
            Name: "Maintenance",
            SubServices: [
                {
                    Name: "Motor Oil Change"
                },
                {
                    Name: "Transmission Oil Change"
                },
                {
                    Name: "Differential Oil Change"
                }
            ]
        },
        {
            Name: "Tires",
            SubServices: [
                {
                    Name: "Rotation"
                },
                {
                    Name: "Replace"
                },
                {
                    Name: "Electronic Balance"
                },
                {
                    Name: "Repair"
                }
            ]
        },
        {
            Name: "Brakes",
            SubServices: [
                {
                    Name: "Pads"
                },
                {
                    Name: "Rotors"
                },
                {
                    Name: "Brake Fluid Flush"
                }
            ]
        },
        {
            Name: "Mechanic Repair",
            SubServices: [
                {
                    Name: "Noise"
                },
                {
                    Name: "Front & Rear Axle"
                },
                {
                    Name: "Leaks"
                },
                {
                    Name: "Rack & Pinion"
                },
                {
                    Name: "Cooling System"
                },

            ]
        },
        {
            Name: "Alignment",
            SubServices: []
        },
        {
            Name: "Air Conditioning",
            SubServices: []
        },
        {
            Name: "Diagnostic",
            SubServices: [
                {
                    Name: "Scanner"
                },
                {
                    Name: "Electrical Evaluation"
                }
            ]
        },
        {
            Name: "Inspection",
            SubServices: [
                {
                    Name: "120 Point"
                }
            ]
        },
        {
            Name: "Charging Service",
            SubServices: [
                {
                    Name: "Battery"
                },
                {
                    Name: "Alternator"
                },
                {
                    Name: "Starter"
                }
            ]
        }
    ]
}